// Issue #31351 follow-up: the offer-page Yup rule for
// `farmLiabilityCoverage.farmOperations` (PR #31354) only fires on the offer
// form. The pre-bind farm UW page submits its own form and recalculates by
// spreading the persisted quote, so legacy offers saved with empty
// `farmOperations` reach ClarionDoor and 5042 there. This helper is the same
// precondition, reused as a backstop on any non-offer-form recalc.
export const isMissingPrimaryFarmOperations = (quote) =>
  Boolean(quote?.includeFarmLiability && !quote?.farmLiabilityCoverage?.farmOperations);
